<template>
    <div class="sbs-panel">
        <!-- @slot Слот по-умолчанию -->
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'SbsPanel',
};
</script>

<style lang="scss">
.sbs-panel {
    display: flex;
    flex-direction: column;
    padding: $base-spacing * 5;
    word-wrap: break-word;
    background-color: $white;
    border-radius: $rounded-15;
}
</style>
